import notAllowedAccessIllustration from '@/assets/not-allowed-access.jpg';
import ErrorMessage from '@/components/ErrorMessage';
import PageLayout from '@/components/general/PageLayout';

const NotAllowedPage = (): JSX.Element => {
  return (
    <PageLayout>
      <ErrorMessage
        data-testid="not-allowed-page"
        title="You don't have access to this page"
        illustration={notAllowedAccessIllustration}
        aboveTitle="Our apologies"
        description={
          <div>
            <p>If you think you shouldn not be seeing this message, please contact you manager.</p>
            <p>Continue navigating by using the menus above and on the left.</p>
          </div>
        }
      />
    </PageLayout>
  );
};

export default NotAllowedPage;
